<template>
  <div v-if="gallery && gallery.length > 0">
    <swiper
      @swiper="setMainSlider"
      :space-between="50"
      :thumbs="{ swiper: thumbsSwiper }"
      class="carGallerySwiper"
    >
      <swiper-slide v-for="slide in gallery" :key="slide.id">
        <img :src="slide.url" :alt="slide.name" class="thumbnail-image" />
      </swiper-slide>
    </swiper>
    <swiper
      @swiper="setThumbsSwiper"
      :watchSlidesVisibility="true"
      :watchSlidesProgress="true"
      :spaceBetween="20"
      :slidesPerView="5"
      :freeMode="true"
      class="carGallerySwiper_thumbs"
    >
      <swiper-slide v-for="(slide, index) in gallery" :key="index" @click="setImage(index)">
        <img :src="slide.url" :alt="slide.name" />
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";

// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from "swiper/core";

SwiperCore.use([Navigation, Thumbs]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      selectedIdx: 0,
      mainSwiper: null,
      thumbsSwiper: null,
    };
  },
  props: {
    gallery: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleImageLoad(event) {
      event.target.classList.remove("placeholder-image");
    },
    setMainSlider(swiper) {
      this.mainSwiper = swiper;
    },
    
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    setImage(index) {
      this.selectedIdx = index;
      this.mainSwiper.slideTo(index);
    },
  },
};
</script>
